import { UntitledIcon } from '@faceup/icons'
import { ulXClose } from '@faceup/icons/ulXClose'
import { Alert as AntAlert, type AlertProps as AntAlertProps } from 'antd'
import { closeIconColors, statusIcons } from './helpers/alertHelper'

type AlertProps = Omit<AntAlertProps, 'showIcon' | 'closable'> & {
  closable?: boolean
}

export const Alert = ({ closable, ...props }: AlertProps) => {
  const alertType = props.type ?? 'info'

  return (
    <AntAlert
      icon={<UntitledIcon icon={statusIcons[alertType]} />}
      showIcon={props.icon !== null}
      closable={
        closable
          ? {
              closeIcon: (
                <UntitledIcon icon={ulXClose} color={closeIconColors[alertType]} size={14} />
              ),
            }
          : false
      }
      {...props}
    />
  )
}
